import { RefObject, useEffect, useState } from 'react'

const useScrollTracking = (ref: RefObject<HTMLDivElement>, thresholdPx: number = 10): boolean => {
  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    const target = ref.current
    if (!target) return

    const handleScroll = () => {
      // Update state based on whether scrollTop is above or below the threshold
      setHasScrolled(target.scrollTop > thresholdPx)
    }

    target.addEventListener('scroll', handleScroll)

    return () => {
      target.removeEventListener('scroll', handleScroll)
    }
  }, [ref, thresholdPx])

  return hasScrolled
}

export default useScrollTracking
